<template>
  <div class="main-container">
    <ResourceLogList />
  </div>
</template>

<script>
import ResourceLogList from "@/components/ResourceLog/List/index.vue";
export default {
  name: "resource-logs",
  components: {
    ResourceLogList,
  },
};
</script>